const isEOC = (file, alt = false) =>
  new Promise((resolve) => {
    var assessmentYear = 0;
    var administrationCode = null;
    if (file.type != 'text/plain') {
      resolve({ isValid: false });
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      if (text.length < 2000) {
        resolve({ isValid: false });
        return;
      }

      const lines = text.split(/\r\n?|\n/);

      if (lines && lines.length > 0) {
        if (!/^-?\d+$/.test(lines[0].slice(2, 4))) {
          resolve({ isValid: false });
          return;
        } else {
          const firstRecord = lines[0]; // e.g. "16230911220912001CROWLEY"
          administrationCode = firstRecord.slice(0, 4);
          assessmentYear = parseInt(firstRecord.slice(2, 4)); // "24" or "23"
          const prefix = firstRecord.slice(0, 2); // "15", "13" or "16" for EOC and "05" for STAAR
          if (prefix === '13' || prefix === '16') {
            // both "13xx" and "16xx" codes map 23 → 24
            assessmentYear += 1;
          }
        }
      }

      for (let i = 0; i < lines.length; i += 1) {
        const line = lines[i];
        if (line) {
          if (
            line.length !== 2000 ||
            line[line.length - 1] !== '.' || //2022 // Blank space for eoc 2021(1623, 1999))
            (assessmentYear < 24 && !/^\s+$/.test(line.slice(1622, 1631))) ||
            (assessmentYear >= 24 && !/^\s+$/.test(line.slice(1626, 1631) || !/^\s+$/.test(line.slice(1669, 1999))))
          ) {
            resolve({ isValid: false });
            return;
          }
          // to differentiate from this year's EOC 2021 from EOC ALT 2021
          // EOC2021 ALT has BLANK between 132-140 while EOC2021 don't
          if (alt && file.name.toUpperCase().indexOf('ALT') == -1) {
            //!/^\s+$/.test(line.slice(132, 141))
            resolve({ isValid: false });
            return;
          }
          if (!alt && file.name.toUpperCase().indexOf('ALT') != -1) {
            ///^\s+$/.test(line.slice(132, 141))
            resolve({ isValid: false });
            return;
          }
        }
      }
      resolve({
        isValid: true,
        assessmentYear: assessmentYear.toString(),
        administrationCode,
      });
    };
    reader.readAsText(file);
  });

export default isEOC;
